export const ADD_TO_SHOPING_CART = 'ADD_TO_SHOPING_CART';
export const REMOVE_FROM_SHOPING_CART = 'REMOVE_FROM_SHOPING_CART';
export const BATCH_REMOVE_FROM_SHOPING_CART = 'BATCH_REMOVE_FROM_SHOPING_CART';
export const SET_SHOPING_CART_ITEM_QUANTITY = 'SET_SHOPING_CART_ITEM_QUANTITY';
export const SET_SHOPING_CART_ITEM_CHECKED = 'SET_SHOPING_CART_ITEM_CHECKED';
export const CLEAN_SHOPING_CART = 'CLEAN_SHOPING_CART';


export const addToShopingCart = (vas, vasPricing, quantity = 1) => ({type: ADD_TO_SHOPING_CART, vas, vasPricing, quantity});
export const setShopingCartItemQuantity = (vasPricing, quantity = 1) => ({type: SET_SHOPING_CART_ITEM_QUANTITY,  vasPricing, quantity});
export const setShopingCartItemChecked = (vasPricing, checked = true) => ({type: SET_SHOPING_CART_ITEM_CHECKED,  vasPricing, checked});
export const removeFromShopingCart = ( vasPricingId) => ({type: REMOVE_FROM_SHOPING_CART, vasPricingId});
export const batchRemoveFromShopingCart = ( vasPricingIds) => ({type: BATCH_REMOVE_FROM_SHOPING_CART, vasPricingIds});
export const cleanShopingCart = () => ({type: CLEAN_SHOPING_CART});



// WEBPACK FOOTER //
// ./src/redux/actions/shopingCart.js